import { Button, CircularProgress, IconButton, InputAdornment, makeStyles, TextField } from "@material-ui/core";
import { useState, useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getOpenPostalCodesExportToolbar, handlePostalCodesExportToolbar, showAlertSnackbar } from "../../reducers/uiSlice";
import FloatingDialog from "../Common/FloatingDialog";
import { useTranslation } from "react-i18next";
import { withStyles } from "@material-ui/styles";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import FullscreenLoading from "../Common/FullscreenLoading";
import { getPostCodeInCircle, getPostCodeInPolygon } from "../../actions/postalCodesExportActions";
import ExcelDownloadButton from "../Common/ExcelDownloadButton";

const useStyles = makeStyles((theme) => ({
    excelMargin: {
        marginRight: 20
    }
}));

function PostalCodesExportToolbar(props){
    const classes = useStyles();
    const dispatch = useDispatch();
    const {t} = useTranslation('postalCodesExport');

    const openPostalCodesToolbar = useSelector(getOpenPostalCodesExportToolbar);

    const [enableExport, setEnableExport] = useState(false);
    const [enable, setEnable] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);

    const handleClosePostalCodesToolbar = useCallback(()=>{
        dispatch(handlePostalCodesExportToolbar(false))
    }, [])

    function downloadXLS(type) {
        if(type === 1) {
            dispatch(getPostCodeInPolygon(props.bounds))
            .then((res) => {
                getResult(res);
            })
            .catch((err) => {
                manageErr(err);
            })
        } else if(type === 2) {
            dispatch(getPostCodeInCircle(props.oPoint, props.radius))
            .then((res) => {
                getResult(res);
            })
            .catch((err) => {
                manageErr(err);
            })
        }
    }
    function getResult(res) {
        setLoading(false);
        setDisabled(false);
        let rows = [];
        if(res.data.postcode) {
            if(res.data.postcode.length > 0) {
                res.data.postcode.map((postCode) => {
                    rows.push({"postal_code": postCode})
                })
            }
        }
        setRows(rows);
    }
    function manageErr(err) {
        dispatch(showAlertSnackbar({
            message: err.message,
            type: 'error'
        }))
        setLoading(false);
        setDisabled(false);
    }
    function postalCodesExport() {
        setLoading(true);
        setDisabled(true);
        if(props.overlayType === 1) {
            if(props.bounds) {
                if(props.bounds.length > 0) {
                    downloadXLS(props.overlayType);
                }
            } 
        } else if(props.overlayType === 2) {
            if(props.oPoint && props.radius) {
                if(props.oPoint.length > 0) {
                    downloadXLS(props.overlayType);
                }
            }
        } else {
            setLoading(false);
            setDisabled(false);
        }
        props.closeOverlay(props.overlayEvent);
    }

    useEffect(() => {
        setEnableExport(props.enableExport);
    }, [props.enableExport])
    useEffect(() => {
        props.handleExportOpen(openPostalCodesToolbar);
        setRows([]);
    }, [openPostalCodesToolbar])

    return (
        <FloatingDialog
            maxWidth='lg'
            key="float"
            id="float"
            open={openPostalCodesToolbar}
            onClose={()=>{
                handleClosePostalCodesToolbar();
                props.closeOverlay(props.overlayEvent);
            }}
            title={t('postal_code_export_title')}
        >
            <div style={{display: 'flex', marginBottom: 10}}>
                <Button 
                    disabled={!enableExport || disabled} 
                    onClick={postalCodesExport}
                    color='secondary'
                    variant="contained"
                    style={{marginRight: 20}}
                >
                    {t('produce')}
                </Button>
                <ExcelDownloadButton 
                    rows={rows || []}
                    name={t('postal_codes')}
                    classes={classes}
                />
                <Button 
                    disabled={!enableExport || disabled} 
                    onClick={() => props.closeOverlay(props.overlayEvent)}
                    color='disabled'
                    variant="contained"
                >
                    {t('clear')}
                </Button> 
            </div>
            <FullscreenLoading open={loading}/>
        </FloatingDialog>
    )
}

export default PostalCodesExportToolbar;